// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1XXdO","inputDescription":"styles_inputDescription__15D6V"};